<template>
    <main style="display: block;">
        <div class="scrollV" >
            <div style="padding: 1rem;" class="newFl" id="voucher-scroll">
                <transition name="view" appear>
                    <div class="flex flex-col w-full mr-4">
                        <div class="mb-4 flex justify-between items-start">
                            <div class="flex items-end">
                                <h1 class="text-2xl leading-none text-black-1 mr-2">Your POS Terminals</h1>
                                <span class="text-sm leading-none text-block-3" style="color: #2ECC71; font-weight: 600;">{{ posCount }} Total</span>
                            </div>
                            <div style="display: flex; flex-flow: row wrap; justify-content: flex-end; align-content: right; text-align: right;">
                              <form @submit.prevent="goToStash" v-if="bvn == 'None****'">
                                <Button class="px-4 py-2 h-10 bg-black-5 text-white hover:bg-black-1 inline-flex" rounded
                                style="display: flex; justify-content: center; align-items: center; margin-left: 1rem;">
                                    <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd"></path></svg>
                                    <span style="text-align: center; font-weight: 600; margin-left: .2rem;">Add BVN</span>
                                </Button> 
                              </form>
                              <form @submit.prevent="$modal.show('newPosModal')" v-if="is_business && bvn != 'None****'">
                                    <Button class="px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light inline-flex" rounded
                                    style="display: flex; justify-content: center; align-items: center;">
                                        <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd"></path></svg>
                                        <span style="text-align: center; font-weight: 600; margin-left: .2rem;" v-if="!isLoading">Add POS</span>
                                    </Button> 
                                </form>
				<JsonCSV v-if="is_business && bvn != 'None****'"
                                        class="px-4 py-2 h-10 bg-blue-normal text-white hover:bg-blue-light inline-flex" rounded
                                  style="display: flex; justify-content: center; align-items: center; margin-left: 1rem; cursor: pointer"
                                        :data="rides_data"
                                        name="Rides.csv"
                                      >
                                      <svg data-slot="icon" class="w-6 h-6" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"></path></svg>
                                      <span style="text-align: center; font-weight: 600; margin-left: .2rem;" v-if="!isLoadingCSV">Gen. CSV</span>
                                        <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingCSV">
                                </JsonCSV>
                                <form @submit.prevent="$modal.show('searchPosModal')" v-if="bvn != 'None****'">
                                    <Button class="px-4 py-2 h-10 bg-black-5 text-white hover:bg-black-1 inline-flex" round
                                    style="display: flex; justify-content: center; align-items: center; margin-left: 1rem;">
                                        <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path></svg>
                                    </Button>
                                </form>
                            </div>
                        </div>
                        <div class="c-table">
                            <table class="w-full mb-2 border-separate">
                                <thead>
                                <tr>
                                    <th v-for="column in columns"
                                        :key="column.name">
                                        <div class="flex items-center justify-center ">
                                            <span class="uppercase text-gray-1 text-sm" v-if="column.label">{{ column.label }}</span>
                                        </div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody v-if="poss.length === 0 && !isLoadingPos">
                                <tr class="mb-3 bg-white border border-solid border-gray-3 shadow-2l">
                                    <td class="p-5 font-bold" :colspan="columns.length">
                                        No POS Terminals Yet
                                    </td>
                                </tr>
                                </tbody>
                                <transition-group v-else tag="tbody" name="table-row">
                                    <tr :key="item.id" class="mb-3 bg-white border border-solid border-gray-3 shadow-2l"
                                        v-for="item in poss">
                                        <td class="p-5" v-for="column in columns" :key="column.name">
                                            <template v-if="'actions' in column">
                                                <Button v-for="(action, index) in column.actions"
                                                        :key="index"
                                                        class="text-primary-normal hover:text-black-1 hover:bg-primary-light"
                                                        @click.native="action.function"
                                                        rounded>
                                                    View
                                                </Button>
                                            </template>
                                            <template v-else>
                                                <div v-if="column.name == 'name'" class="flex items-center justify-start">
                                                    <div>
                                                      <p class="text-left leading-tight">{{ item.name}}</p>
                                                    </div>
                                                </div>
                                                <div v-if="column.name == 'sn'" class="flex items-center justify-center">
                                                    <div>
                                                      <p class="text-left leading-tight">{{ item.sn}}</p>
                                                    </div>
                                                </div>
						<div v-if="column.name == 'balance'" class="flex items-center justify-center">
                                                    <div>
                                                      <p class="text-left leading-tight">₦{{ Intl.NumberFormat().format(item.balance) }}</p>
                                                    </div>
                                                </div>
                                                <div v-if="column.name == 'date'" class="flex items-center justify-center">
                                                    <div>
                                                        <p class="text-center leading-tight">{{ item.date_updated | dateAs }}</p>
                                                    </div>
                                                </div>
                                                <div v-if="column.name == 'action' && is_business" class="flex items-center justify-center">
                                                    <div>
                                                      <button style="color: #3498DB; margin-right: 5px;" @click="viewPos(item)">View</button>
                                                      <button style="color: #2ECC71" @click="openEditPosModal(item)">Update</button>
                                                    </div>
                                                </div>
                                            </template>
                                        </td>
                                    </tr>
                                </transition-group>
                            </table>
                            <div v-if="isLoadingVouchers">
                                <div class="loading-animation" style="width: 100%; height: 60px;">
                                    <span style="color: transparent">y</span>
                                </div>
                                <div class="loading-animation" style="width: 100%; height: 60px; margin-top: 1rem;">
                                    <span style="color: transparent">y</span>
                                </div>
                                <div class="loading-animation" style="width: 100%; height: 60px; margin-top: 1rem;">
                                    <span style="color: transparent">y</span>
                                </div>
                                <div class="loading-animation" style="width: 100%; height: 60px; margin-top: 1rem;">
                                    <span style="color: transparent">y</span>
                                </div>
                                <div class="loading-animation" style="width: 100%; height: 60px; margin-top: 1rem;">
                                    <span style="color: transparent">y</span>
                                </div>
                                <div class="loading-animation" style="width: 100%; height: 60px; margin-top: 1rem;">
                                    <span style="color: transparent">y</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <modal name="newPosModal" :adaptive="true" width="520" height="720" :styles="{'border-radius': '20px'}">
            <button @click="$modal.hide('newPosModal')" style="float: right; padding: 1rem;">
            ❌
            </button>
            <div class="tvv2">
            <div>
                <h3 class="bold-font" style="color: #0E6655; font-size: 25px;">Add a POS Terminal</h3>
                <form class="page2" @submit.prevent="createPos()">

                    <label class="field field_v1">
                      <input class="field__input" type="text" placeholder="e.g. Teller 1" v-model="new_pos.name" required>
                      <span class="field__label-wrap">
                          <span class="field__label">POS Name</span>
                      </span>
                    </label>
                    
                    <label class="field field_v1">
                      <input class="field__input" type="text" placeholder="e.g. 000111222" v-model="new_pos.sn" required>
                      <span class="field__label-wrap">
                          <span class="field__label">Serial Number</span>
                      </span>
                    </label>

                    <div>
                      <input type="checkbox" name="svB" v-model="new_pos.canTr">
                      <span>  Can Make Transfers?</span>
                    </div>
                    
                    <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
                    :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                        <span style="text-align: center; font-weight: 800;" v-if="!isLoadingEditV">Confirm</span>
                        <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingEditV">
                    </Button> 
                </form>
            </div>
            </div>
        </modal>
	<modal name="editPosModal" :adaptive="true" width="520" height="720" :styles="{'border-radius': '20px'}">
            <button @click="$modal.hide('editPosModal')" style="float: right; padding: 1rem;">
            ❌
            </button>
            <div class="tvv2">
            <div>
                <h3 class="bold-font" style="color: #0E6655; font-size: 25px;">Edit POS Details</h3>
                <form class="page2" @submit.prevent="editPos()">

                    <label class="field field_v1">
                      <input class="field__input" type="text" placeholder="e.g. Teller 1" v-model="posModal.name" required>
                      <span class="field__label-wrap">
                          <span class="field__label">POS Name</span>
                      </span>
                    </label>
                    <label class="field field_v1" style="margin-bottom: 1rem; width: 100%;">
                      <input class="field__input" type="number" step=".01" placeholder="e.g. 1000" v-model="posModal.balance" required>
                      <span class="field__label-wrap">
                      <span class="field__label">Amount</span>
                      </span>
                    </label>

                    <div>
                      <input type="checkbox" name="svB" v-model="posModal.canTr">
                      <span>  Can Make Transfers?</span>
                    </div>
                    
                    <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
                    :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                        <span style="text-align: center; font-weight: 800;" v-if="!isLoadingEditV">Edit POS Name</span>
                        <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingEditV">
                    </Button> 
		    <a class="w-50 px-4 py-2 bg-blue-normal text-white hover:bg-green-light" rounded @click="generateActDetails()"
                    :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;" v-if="posModal.account_number == null">
                        <span style="text-align: center; font-weight: 800; color: white;" v-if="!isLoadingEditV">Generate Account Number</span>
                        <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingEditV">
                    </a> 
                    <h3 class="bold-font" style="color: #0E6655; font-size: 25px;" v-if="posModal.account_number != null">{{ posModal.account_number }}</h3>
                    <h3 class="bold-font" style="color: #0E6655; font-size: 25px;" v-if="posModal.account_name != null">{{ posModal.account_name }}</h3>
                </form>
            </div>
            </div>
        </modal>
        <modal name="viewPosModal" :adaptive="true" width="520" height="720" :styles="{'border-radius': '20px'}">
            <button @click="$modal.hide('viewPosModal')" style="float: right; padding: 1rem;">
            ❌
            </button>
            <div class="tvv2">
              <div>
                <h3 class="bold-font" style="color: #0E6655; font-size: 25px;">View Recent POS Transactions</h3>
                <div class="page2" style="margin-bottom: 5rem;">
                  <!-- Display active subscriptions here -->
                  <button v-for="(item, index) in transactions" :key="index" :style="{ float: 'left', padding: '1rem', border: selectedOption === index ? '3px solid #2ECC71' : '1px solid grey', 'outline': 'none !important', 'border-radius': '20px', backgroundColor: 'transparent', color: selectedOption === index ? 'green' : 'black' }">
                    <span style="float: left; text-align: left;">
                      <b v-if="item.trans_type == 'CHARGES'">Card Subscription </b>
                      <b v-if="item.trans_type == 'CARD'">Card Topup</b>
                      <b v-if="item.trans_type != 'CHARGES' && item.trans_type != 'CARD'">Payment</b>
                      <br>
                      {{ item.date_created | dateFor }}
                    </span>
                    <span :style="{'font-weight': 'bold', 'float': 'right', 'color': item.trans_type != 'CHARGES' && item.trans_type != 'CARD' ? 'green': 'red', 'margin-top': '1rem'}">₦{{ Intl.NumberFormat().format(item.amount) }}</span>
                  </button>
                  <div v-if="isLoadingEditV">
                    <div class="loading-animation" style="width: 100%; height: 40px;">
                      <span style="color: transparent">y</span>
                    </div>
                    <div class="loading-animation" style="width: 100%; height: 40px; margin-top: 1rem;">
                      <span style="color: transparent">y</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
        </modal>
        <modal name="searchPosModal" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
            <button @click="$modal.hide('searchPosModal')" style="float: right; padding: 1rem;">
            ❌
            </button>
            <div class="tvv2">
            <div class="page2">
               <h3 class="bold-font" style="color: #0E6655; font-size: 25px;">Search Your POS Terminals</h3>
                <label class="field field_v1">
                    <input class="field__input" placeholder="e.g. cashier or 12345678" v-model="spos" required @keyup="searchTimeOut">
                    <span class="field__label-wrap">
                    <span class="field__label">POS Name or S/N</span>
                    </span>
                </label>
                <div v-if="isLoadingUsers">
                <div class="loading-animation" style="width: 90%; margin-top: 1rem; margin-left: 1rem;">
                    <span style="color: transparent">y</span>
                </div>
                <div class="loading-animation" style="width: 90%; margin-top: 1rem; margin-left: 1rem;">
                    <span style="color: transparent">y</span>
                </div>
                <div class="loading-animation" style="width: 90%; margin-top: 1rem; margin-left: 1rem;">
                    <span style="color: transparent">y</span>
                </div>
                <div class="loading-animation" style="width: 90%; margin-top: 1rem; margin-left: 1rem;">
                    <span style="color: transparent">y</span>
                </div>
                </div>
                <h4 v-if="nfo && !isLoadingUsers" style="color: red;">POS Not Found</h4>
                <div class="usersRow" v-if="options.length > 0" v-for="(option) in options" :key="option.id">
                    <div class="rS" style="display: flex; width: 80%">
                        <div style="padding-left: .5rem; text-align: left;">
                            <h4>{{ option.name }}</h4> 
                            <p style="font-size: 15px;">{{ option.sn }}</p>
			    <p style="font-size: 15px;"><b>Rides:</b> {{ option.pos_count }}</p>
                        </div> 
                    </div>
                    <div class="rS" style="width: 20%; margin-top: .7rem;"> 
                        <button type="button" @click="viewPos(option)" style="color: #2ECC71; font-weight: 600;">View</button>
                    </div>
                </div>
            </div>
            
            </div>
        </modal>
    </main>
</template>

<script>
  import axios from "axios";
  import router from "../../router";
  import Button from "../../components/Button";
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';
  import JsonCSV from "vue-json-csv";

  var utc = require('dayjs/plugin/utc')
  var timezone = require('dayjs/plugin/timezone');

  dayjs.extend(utc);
  dayjs.extend(timezone);

  export default {
    name: "poss",
    components: {
      Button,
      JsonCSV,
    },
    data() {
      return {
        url: process.env.VUE_APP_BASE_URL,
        nodeurl: process.env.VUE_APP_NODE_URL,
        balance: localStorage.getItem("balance"),
        is_business: localStorage.getItem("is_business") == 'true' ? true : false,
        is_staff: localStorage.getItem("staff_username") ? true : false,
        businessName: localStorage.getItem("on_business_name"),
        token: this.decrypt(localStorage.getItem("token")),
        user_id: this.decrypt(localStorage.getItem("user_id")),
        voucherCount: 0,
        posCount: 0,
        bvn: localStorage.getItem("bvn"), 
        isLoading: false,
        isLoadingVouchers: false,
        isLoadingPos: false,
        isLoadingCSV: false,
        scust: null,
        transactions: [],
        rides_data: [],
        poss: [],
        posModal: {},
        nextPage: null,
        nextPosPage: null,
        avatarSize: 8,
        ammtt: true,
        freqq: false,
        neww: false,
        oldd: false,
        isLoadingUsers: false,
        options: [],
        options2: [],
        nfo: false,
        new_pos: {canTr: true},
        new_voucher: {amount: '100.00', percentage: '0.00', exp_date: new Date().toISOString()},
        minDatetime: new Date().toISOString(),
        tempAmt: null,
        tempPerc: null,
        spos: null,
        timer: null,
        isLoadingEditV: false,
        isDisabled: true,
        buttonType: 'submit', 
        departments: [],
        chosenUser: {},
	selectedOption: -1,
        columns: [
            {name: 'name', label: 'Name', required: true, sortable: false},
            {name: 'sn', label: 'S/N', required: true, sortable: false},
	    {name: 'balance', label: 'Balance', required: true, sortable: false},
            {name: 'date', label: 'Date Activated', required: true, sortable: false},
            {name: 'action', label: '', required: true, sortable: false},
        ],
      }
    },
     mounted() {
      this.checkLoggedIn();
      const listElm = document.querySelector('#voucher-scroll');
      listElm.addEventListener('scroll', e => {
        if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          this.getMorePoss();
        }
      });
    },
    created() {
      document.title = "Zinger - POS";
      dayjs.extend(relativeTime);
    },
    filters: {
      diffForHumans: (date) => {
        if (!date){
            return null;
        }
        return dayjs.tz(date,"Europe/London").fromNow();
      },
      dateFor: (date) => {
        date = date.substring(0, date.indexOf("."))
        return dayjs(date).format('ddd, MMM D, YYYY h:mm A');
      },
      dateAs: (date) =>{
        if (!date){
            return null;
        }
        return dayjs(date).format('MM-DD-YYYY');
      }
    },
    methods: {
        checkLoggedIn() {
          if(!this.is_staff && localStorage.getItem("is_business") == 'true'){
            if (!this.token) {
                router.push({ name: "login", query: { redirect: "/pos" } });
            }else if(this.decrypt(localStorage.getItem("verified_status")) == 'false'){
                router.push("/verify");
            }else if(localStorage.getItem("is_business") == 'false'){
                if(this.decrypt(localStorage.getItem("reached_limit")) == 'true' && localStorage.getItem("is_upgraded") == 'false'){
                    router.push("/upgrade");
                }
                this.getPoss();
            }else{
                this.getPoss();
            }
          }else{
              router.push("/");
          }
        },
        getPoss(){
          this.isLoadingPos = true;
	  this.isLoadingCSV = true;
          axios.get(this.url + "api/v1/user-poss/" + this.user_id + "/",
          { headers: { authorization: "Token " + this.token } }).then(response => {
            // console.log(response.data)
            this.poss = response.data.results;
            this.posCount = response.data.total;
            if(response.data.links.next != null){
                this.nextPosPage = response.data.links.next;
            }else{
                this.nextPosPage = null;
            }
            this.isLoadingPos = false;
	    this.generatePOSCSV();
          }).catch(err => {
              // console.log(err)
              this.isLoadingPos = false;
              this.isLoadingCSV = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });
        },
        getMorePoss(){
          // console.log("more")
          if(this.nextPosPage != null){
            this.isLoadingVouchers = true;
            axios.get(this.nextPosPage,
            { headers: { authorization: "Token " + this.token } }).then(response => {
                this.poss = [...this.poss,...response.data.results];
                if(response.data.links.next != null){
                    this.nextPosPage = response.data.links.next;
                }else{
                    this.nextPosPage = null;
                }
                this.isLoadingVouchers = false;
                // console.log(response.data)
            }).catch(err => {
                this.isLoadingVouchers = false;
                this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          }
        },
	generatePOSCSV(){
          axios.get(this.url + "api/v1/user-poss-unlimited/" + this.user_id + "/",
          { headers: { authorization: "Token " + this.token } }).then(response => {
            // console.log(response.data)
            this.rides_data = response.data;
            const tData = response.data.map((data) => {
              return {
                "SN": data.sn,
                "POS Name": data.name,
                "Total Rides": data.pos_count,
                "POS Account Name": data.account_name,
                "POS Account Number": data.account_number,
                "Balance": data.balance,
                "Total Sales": data.sub_amount.bundle__amount__sum,
                "Date": dayjs(data.date_created).format("ddd, MMM D, YYYY h:mm A"),
              };
            });
            this.rides_data = tData;
            this.isLoadingCSV = false;
          }).catch(err => {
              // console.log(err)
              this.isLoadingCSV = false;
              this.$toast.error('Error Generating CSV', {duration: 3000, position: "top-right"});
          });
        },
        createPos(){
          this.isLoadingEditV = true;
          this.new_pos.user = this.user_id;
          // console.log(this.new_pos)
          axios.post(this.url + "api/v1/assign-pos/", this.new_pos,
          { headers: { authorization: "Token " + this.token } }).then(response => {
              let tempD = [response.data];
              this.poss = [...tempD,...this.poss];
              this.isLoadingEditV = false;
              this.$modal.hide('newPosModal');
              this.$toast.success('POS Terminal Successfully Added.', {duration: 3000, position: "top-right"});
          }).catch(err => {
              this.isLoadingEditV = false;
              if(err.response){
                if(err.response.data.detail){
                  this.$toast.error(err.response.data.detail, {duration: 5000, position: "top-right"});
                }
              }else{
                this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
              }
          });
        },
        searchTimeOut() {  
          if (this.timer) {
              clearTimeout(this.timer);
              this.timer = null;
          }
          this.timer = setTimeout(() => {
            this.searchPos();
          }, 800);
        },
        searchPos(){
          if(this.spos != null && this.spos != '' && this.spos != ' '){
            this.isLoadingUsers = true;
            axios.get(this.url + "api/v1/user-poss/" + this.user_id + "/?search=" + this.spos,
            { headers: { authorization: "Token " + this.token } }).then(response => {
                this.options = response.data.results;
                // console.log(this.options)
                if(response.data.total == 0 || this.options.length == 0){
                    this.nfo = true;
                    this.options = [];
                }else{
                    this.nfo = false;
                }
                this.isLoadingUsers = false;
            }).catch(err => {
                // console.log(err)
                this.isLoadingUsers = false;
            });
          }else{
            this.options = [];
          }
        },
        openEditPosModal(item){
          this.posModal = item;
          this.$modal.show('editPosModal');
        },
        editPos(){
          this.isLoadingEditV = true;
          
          axios.put(this.url + "api/v1/pos/" + this.posModal.id + "/", this.posModal,
          { headers: { authorization: "Token " + this.token } }).then(response => {
              this.isLoadingEditV = false;
              this.$modal.hide('editPosModal');
              this.posModal = {};
              this.$toast.info('POS Details Updated.', {duration: 3000, position: "top-right"});
          }).catch(err => {
              this.isLoadingEditV = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });
        },
	generateActDetails(){
          this.isLoadingEditV = true;
          
          axios.post(this.url + "api/v1/generate-pos-act-details/", this.posModal,
          { headers: { authorization: "Token " + this.token } }).then(response => {
              this.isLoadingEditV = false;
              // console.log(response.data);
              if(response.data.response_code == '00'){
                this.posModal.account_name = response.data.account_name;
                this.posModal.account_number = response.data.account_number;
		this.$toast.info('POS Account Number Generated.', {duration: 3000, position: "top-right"});
              }else{
                this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
              }
          }).catch(err => {
              this.isLoadingEditV = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });
        },
        viewPos(item){
          this.$modal.hide('searchPosModal');
          this.$modal.show('viewPosModal');
          this.isLoadingEditV = true;

          axios.get(this.url + "api/v1/pos-transactions/" + item.id + "/" + this.user_id + "/",
          { headers: { authorization: "Token " + this.token } }).then(response => {
              // console.log(response.data)
              this.transactions = response.data.results;
              this.isLoadingEditV = false;
          }).catch(err => {
              this.isLoadingEditV = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });
        },
        goToStash(){
          router.push("/stash")
        },
    }
  }
</script>

<style lang="css" scoped>
.scrollV{
    display: flex;
    flex-direction: column;
    height: calc(100vh - 117px);
}

select{
  background: transparent url("data:image/svg+xml;utf8,<svg style='float: right;' width='24' height='24' class='w-6 h-6' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'></path></svg>") no-repeat;
  background-position: right 5px top 50%;
}

.newFl{
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 30px;
  scroll-behavior: smooth;
}

.usersRow{
  display: flex;
  flex-flow: row wrap;
  align-content: stretch;
  padding: 1rem;
}

.rS {
  width: 100%;
}

.rowrapper{
  display: flex;
  flex-flow: row wrap;
  /* justify-content: center; */
  align-content: stretch;
}
@media screen and (max-width: 378px){
  .rowrapper{
    justify-content: center;
  }
}

.voucherRow{
  display: flex;
  flex-flow: row wrap;
  align-content: stretch;
  padding: 1rem;
}

.rS {
  width: 100%;
  /* flex: 1 1 0rem; */
}

.avatar {
  vertical-align: middle;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.balD{
  background: #2ECC71; 
  padding-bottom: 1rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 10px;
  max-height: 115px;
  max-width: 500px;
}
.dtss{
  background: #000000; 
  padding-bottom: 1rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  margin-bottom: 1rem;
  border-radius: 10px;
  max-height: 115px;
  min-width: 200px;
  max-width: 500px;
}
.btnsD {
  height: 100px;
  width: 100px;
  /* margin-top: .5rem; */
  margin-left: 3rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  cursor: pointer;
  /* text-align: center; */
}
.trTbl{
  background: #ffffff; 
  padding-bottom: 1rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 10px;
  height: 300px;
  width: 100%;
  margin-top: 5.5rem;
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /* padding-bottom: 30px; */
  scroll-behavior: smooth;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 33px 100px;

}
.btnsD:hover{
  background: #EAFAF1 !important;
}
.btnsTxt{
  margin-top: .2rem;
  margin-left: 3rem;
}
.btnsSvg{
  padding: 1.5rem;
}
h1, h2, h3, h4, h5, h6 {
    letter-spacing: -.5px;
    line-height: 1.4;
    margin: 5px 0;
    font-weight: 600;
    font-family: "CW BR Firma",sans-serif;
}
sup{
  vertical-align: middle;
  font-size: .43em;
  font-weight: 400;
  top: -.62em;
}
sub{
    bottom: .05em;
    margin-left: -4px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0;
    opacity: 1;
    font-size: .4em;
}
@media screen and (max-width: 600px){
  .balH{
    font-size: 2.0rem !important;
  }
}
@media screen and (max-width: 350px){
  .balH{
    font-size: 1.7rem !important;
  }
}
@media screen and (max-width: 453px){
  .balD{
    margin-bottom: 1rem;
  }
}

a{
  font-weight: 600;
  font-family: "CW BR Firma",sans-serif;
  color: #2ECC71;
}

#ahov:hover{
  color: #82E0AA;
}

.bold-font{
  font-weight: 700;
}

.js-pscroll {
  position: relative;
  overflow: hidden;
}


.table100 .ps__rail-x {
  z-index: 1010;
  height: 6px;
  background-color: transparent;
  opacity: 1 !important;
  bottom: 10px;
}

.table100 .ps__rail-x::before {
  content: "";
  display: block;
  position: absolute;
  background-color: #e6e6e6;
  height: 100%;
  width: calc(100% - 30px);
  left: 15px;
  top: 0px;
}

.table100 .ps__rail-x .ps__thumb-x {
  height: 100%;
  bottom: 0;
  background-color: transparent;
  opacity: 1 !important;
}

.table100 .ps__rail-x .ps__thumb-x::before {
  content: "";
  display: block;
  position: absolute;
  background-color: #b3b3b3;
  height: 100%;
  width: calc(100% - 30px);
  top: 0;
  left: 15px;
}


/*//////////////////////////////////////////////////////////////////
[ Table ]*/

.container-table100 {
  /* margin: 0 auto; */
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;

  background: #ffffff; 
  padding-bottom: 1rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 10px;
  height: 300px;
  /* width: calc(90vw - 117px); */
  width: 100%;
  
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /* padding-bottom: 30px; */
  scroll-behavior: smooth;
  display: flex;
  flex-wrap: wrap;
  /* align-items: center;
  justify-content: center; */
  /* padding: 33px 100px; */
}

.wrap-table100 {
  width: 100%;
}

/*//////////////////////////////////////////////////////////////////
[ Table ]*/
.table100 {
  background-color: #fff;
}

table {
  width: 100%;
}

th, td {
  /* font-weight: unset; */
  padding-right: 10px;
}

.column1 {
  width: 100%;
  padding-left: 40px;
}

.column2 {
  width: 225px;
  padding-left: 55px;
}

.column3 {
  width: 105px;
}

.column4 {
  width: 195px;
}

.column5 {
  width: 235px;
}

.column6 {
  width: 170px;
}

.column7 {
  width: 330px;
}

.column8 {
  width: 305px;
}

.table100 th {
  padding-top: 21px;
  padding-bottom: 21px;
}

.table100 td {
  padding-top: 16px;
  padding-bottom: 16px;
}


/*==================================================================
[ Fix col ]*/
.table100 {
  width: 100%;
  position: relative;
}

.table100-firstcol {
  background-color: #fff;
  position: absolute;
  z-index: 1000;
  width: 310px;
  top: 0;
  left: 0;
}

.table100-firstcol table {
  background-color: #fff;
}

.wrap-table100-nextcols {
  width: 100%;
  overflow: auto;
  /* padding-left: 310px; */
  padding-bottom: 28px;
}

.table100-nextcols table{
  table-layout: fixed;
}

.shadow-table100-firstcol {
  box-shadow: 8px 0px 10px 0px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 8px 0px 10px 0px rgba(0, 0, 0, 0.05);
  -webkit-box-shadow: 8px 0px 10px 0px rgba(0, 0, 0, 0.05);
  -o-box-shadow: 8px 0px 10px 0px rgba(0, 0, 0, 0.05);
  -ms-box-shadow: 8px 0px 10px 0px rgba(0, 0, 0, 0.05);
}

.table100-firstcol table {
  background-color: transparent;
}

/*==================================================================
[ Ver1 ]*/

.table100.ver1 th {
  font-family: "CW BR Firma",sans-serif;
  font-size: 14px;
  color: #333333;
  line-height: 1.4;
  font-weight: 600;
  /* text-transform: uppercase; */
}

.table100.ver1 td {
  font-family: Roboto-Medium;
  font-size: 15px;
  line-height: 1.4;
}

.table100.ver1 .table100-firstcol td {
  color: #666666;
}

.table100.ver1 .table100-nextcols td {
  color: #999999;
}

.table100.ver1 tr {
  border-bottom: 1px solid #f2f2f2;
}
.hvr:hover{
  background: #ECF0F1;
  cursor: pointer;
}
@keyframes placeHolderShimmer {
   0% {
    background: #ececec;
  }
  
  30% {
    background: #F7F7F7;
  }
 
  50% {
    background: #ececec;
  }
  
  80% {
    background: #F7F7F7;
  }
  
  100% {
    background: #ececec;
  }
}

.loading-animation {
  animation: placeHolderShimmer 3s infinite;
}
.tvv{
  display: flex; 
  flex-wrap: wrap; 
  flex-direction: column;
  height: 300px; 
  width: 100%;
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  scroll-behavior: smooth;  
  justify-content: center; 
  align-items: center; 
  text-align: center;
}
.tvv2{
  /* padding-top: 3rem; */
  text-align: center; 
  height: 100%; 
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  scroll-behavior: smooth;  
}
.qrClass{
  display: flex;
  align-items: center; 
  flex-direction: column;
  margin: 0 auto;
}
.field__input{ 
  --uiFieldPlaceholderColor: var(--fieldPlaceholderColor, #767676);
  /* color: #ffffff; */
  
  background-color: transparent;
  border-radius: 0;
  border: none;

  -webkit-appearance: none;
  -moz-appearance: none;

  font-family: inherit;
  font-size: inherit;
}

.field__input:focus::-webkit-input-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

.field__input:focus::-moz-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

/*
=====
CORE STYLES
=====
*/

.field{
  --uiFieldBorderWidth: var(--fieldBorderWidth, 2px);
  --uiFieldPaddingRight: var(--fieldPaddingRight, 1rem);
  --uiFieldPaddingLeft: var(--fieldPaddingLeft, 1rem);   
  --uiFieldBorderColorActive: var(--fieldBorderColorActive, rgba(22, 22, 22, 1));

  display: var(--fieldDisplay, inline-flex);
  position: relative;
  font-size: var(--fieldFontSize, 1rem);
}

.field__input{
  box-sizing: border-box;
  width: var(--fieldWidth, 100%);
  height: var(--fieldHeight, 3rem);
  padding: var(--fieldPaddingTop, 1.25rem) var(--uiFieldPaddingRight) var(--fieldPaddingBottom, .5rem) var(--uiFieldPaddingLeft);
  border-bottom: var(--uiFieldBorderWidth) solid var(--fieldBorderColor, rgba(0, 0, 0, .25));  
}

.field__input:focus{
  outline: none;
}

.field__input::-webkit-input-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input::-moz-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input:focus::-webkit-input-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__input:focus::-moz-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__label-wrap{
  box-sizing: border-box;
  pointer-events: none;
  cursor: text;
  /* color: #ffffff; */

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.field__label-wrap::after{
  content: "";
  box-sizing: border-box;
  width: 100%;
  height: 0;
  opacity: 0;

  position: absolute;
  bottom: 0;
  left: 0;
}

.field__input:focus ~ .field__label-wrap::after{
  opacity: 1;
}

.field__label{
  position: absolute;
  left: var(--uiFieldPaddingLeft);
  top: calc(50% - .5em);

  line-height: 1;
  font-size: var(--fieldHintFontSize, inherit);

  transition: top .2s cubic-bezier(0.9, -0.15, 0.1, 1.15), opacity .2s ease-out, font-size .2s ease-out;
  will-change: bottom, opacity, font-size;
}

.field__input:focus ~ .field__label-wrap .field__label,
.field__input:not(:placeholder-shown) ~ .field__label-wrap .field__label{
  --fieldHintFontSize: var(--fieldHintFontSizeFocused, .75rem);

  top: var(--fieldHintTopHover, .25rem);
}

/* 
effect 1
*/

.field_v1 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transition: opacity .2s ease-out;
  will-change: opacity;
}

/* 
effect 2
*/

.field_v2 .field__label-wrap{
  overflow: hidden;
}

.field_v2 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transform: translate3d(-105%, 0, 0);
  will-change: transform, opacity;
  transition: transform .285s ease-out .2s, opacity .2s ease-out .2s;
}

.field_v2 .field__input:focus ~ .field__label-wrap::after{
  transform: translate3d(0, 0, 0);
  transition-delay: 0;
}

/*
effect 3
*/

.field_v3 .field__label-wrap::after{
  border: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  will-change: opacity, height;
  transition: height .2s ease-out, opacity .2s ease-out;
}

.field_v3 .field__input:focus ~ .field__label-wrap::after{
  height: 100%;
}

/*
=====
LEVEL 4. SETTINGS
=====
*/

.field{
  --fieldBorderColor: #ABEBC6;
  --fieldBorderColorActive: #239B56;
}

/*
=====
DEMO
=====
*/

.page{
  background: transparent; 
  padding-left: 6rem;
  padding-right: 6rem;
  width: 100%;
  display: grid;
  grid-gap: 30px;
}
.page2{
  background: transparent; 
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;
  display: grid;
  grid-gap: 30px;
}

.view-leave-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
}

.view-enter-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
    transition-delay: 0.2s;
}

.view-enter, .view-leave-to {
    opacity: 0;
}

.view-enter-to, .view-leave {
    opacity: 1;
}

.c-table table { border-spacing: 0 1rem;  }

.c-btn-sortable svg { transition: transform .15s ease-in; }
.c-btn-sortable .is-asc { transform: rotateZ(0deg); }
.c-btn-sortable .is-dsc { transform: rotateZ(180deg); }

.c-expand-section { @apply flex justify-center items-center }
.c-expand-section::before, .c-expand-section::after {
    @apply block bg-black-4;
    height: 1px;
    content: "";
    -webkit-box-flex: 1;
    flex: auto;
    background-clip: content-box;
}
.table-row-move { transition: transform 1s; }
</style>
